import React, { useContext, useState } from 'react';
import ModalButton from './ModalButton';
import { AppContext } from '../App';
import useRemote from '../hooks/useRemote';

const FirstTimeLoginModal = ({closeModal})=>{
	const app = useContext(AppContext);
	const remote = useRemote();

	const [ rememberMe, setRememberMe ] = useState(false);

	const act = ()=>{
		app.setFirstLogin(false);
		if (rememberMe) {
			remote.getRefreshToken()
				.then(()=>{
					closeModal();
				});
		} else {
			closeModal();
		}
	}
	return <div>
		<div>Welcome to <strong>{app.school.name}</strong>'s Jumbletree LEARN account</div>
		<div>To make logging in easier, we can store your login details for next time.  Please use this with caution - never use on a shared or public computer!</div>
		<div>
			<input type="checkbox" checked={rememberMe} onChange={e=>setRememberMe(e.target.checked)} /> Remember Me
		</div>
		<ModalButton text="Get Started" onClick={act} />
	</div>
}

export default FirstTimeLoginModal;